<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <addHeader
          :title="$t('Add income')"
          :description="$t('From here you can create a new income')"
          v-if="$route.name == 'incomesCreate'"
        />
        <addHeader
          :title="$t('Income adjustment')"
          :description="$t('From here you can modify the income information')"
          v-if="$route.name == 'incomesEdit'"
        />
        <div class="mb-4 row">
          <connectionInput
            :title="$t('Numbering of allowances')"
            :group="$t('Groups')"
            v-model="item.invoice_group"
            :disabled="$checkRole('expenses_edit_item') ? false : true"
            :hasErorr="errors.invoice_group"
            :error="$t('This field is required')"
            :values="$database.invoiceGroups"
            v-if="$route.name == 'incomesCreate'"
          />
          <formInput
            :title="$t('Allowance Code')"
            v-model="item.code"
            :disabled="true"
            v-if="$route.name == 'incomesEdit'"
            maxlength="255"
          />
          <subFileInput
            :title="$t('Invoice file')"
            v-model="item.file"
            :file="item.file"
            :path="'invoices'"
            :hasErorr="errors.file"
            :error="$t('Choose a Suitable file')"
          />
          <formInput :title="$t('Reference')" v-model="item.refrance" maxlength="255" />
          <formInput :title="$t('paid for')" v-model="item.cash_to" maxlength="255" />

          <div class="form-group row" :class="'col-md-6'">
            <label :class="'col-md-4'">{{ $t('Date') }}</label>
            <div :class="'col-md-7'">
              <div class="icon-input w-100 to-left">
                <span><i class="far fa-calendar"></i></span>
                <VueCtkDateTimePicker
                  :label="$t('Choose time and date')"
                  :button-now-translation="$t('Now')"
                  v-model="item.date"
                  :disabled="$checkRole('expenses_edit_item') ? false : true"
                  format="YYYY-MM-DD hh:mm a"
                  color="#631263"
                  button-color="#631263"
                />
              </div>
            </div>
          </div>
          <searchGroupInput
            :type="'supplier'"
            :values="$database.suppliers"
            :inputs="[{ title: $t('Supplier'), show: 'name' }]"
          />

          <searchGroupInput
            :type="'customer'"
            :values="$database.customers"
            :inputs="[{ title: $t('Customer'), show: 'name' }]"
          />

          <searchGroupInput
            :type="'project'"
            :values="$database.projects"
            :inputs="[{ title: $t('Project'), show: 'name' }]"
            v-if="$site.projects_allow"
          />
          <connectionInput
            :disabled="item.project_id == 0"
            :title="$t('Project output')"
            :group="$t('Project outputs')"
            v-model="item.project_item_id"
            :values="$database.projectItems.filter((el) => el.project_id == item.project_id)"
            v-if="$site.projects_allow"
          />

          <selectInput
            :title="$t('Situation')"
            v-model="item.status"
            :values="[
              { name: $t('Draft'), value: 0 },
              { name: $t('Approved'), value: 1 }
            ]"
          />

          <dvider
            :title="$t('Accounts information')"
            :description="$t('Account information details')"
          />

          <selectInput
            :title="$t('type')"
            v-model="item.type"
            :values="[
              { name: $t('Paid'), value: 0 },
              { name: $t('Worthy'), value: 1 }
            ]"
          />

          <monyInput
            :title="$t('Cost')"
            v-model="item.cost"
            :hasErorr="errors.cost"
            :error="$t('Cost must be greater than')"
          />

          <searchGroupInput
            :type="'safe'"
            :values="$database.safes"
            :inputs="[{ show: 'name' }, { show: 'balance', moany: true }]"
          />
          <searchGroupInput
            :type="'paymentMethod'"
            :values="$database.paymentMethods"
            :inputs="[{ show: 'name' }]"
          />

          <connectionInput
            :title="$t('Basic classification')"
            :group="$t('classifications')"
            v-model="item.income_section_id"
            :hasAdd="false"
            :values="this.$database.incomeSections.filter((el) => el.income_section_id == 0)"
            :value="item.income_section_id"
          />
          <connectionInput
            v-if="item.income_section_id"
            :title="$t('Subclassification')"
            :group="$t('classifications')"
            v-model="item.sup_income_section_id"
            :hasAdd="false"
            :open="'addIncomeSection'"
            :values="
              this.$database.incomeSections.filter(
                (el) => el.income_section_id == item.income_section_id
              )
            "
            :value="item.sup_income_section_id"
          />

          <dvider :title="$t('Payment notes')" :description="$t('Payment notes details')" />

          <formTextarea :title="$t('That about')" v-model="item.description" />
          <formTextarea :title="$t('Note')" v-model="item.notes" />
          <hr class="mt-5 mb-5 col-12" />
          <a
            @click="saveItem()"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'incomesCreate' && !$parent.stopEdit"
          >
            {{ $t('Add income') }}
          </a>
          <a
            @click="saveItem()"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'incomesEdit' && !$parent.stopEdit"
          >
            {{ $t('Edi income') }}
          </a>
          <loading v-if="$parent.stopEdit" />
        </div>
      </div>
    </div>
    <addPaymentMethod v-if="model == 'addPaymentMethod'" />
    <addTaxe v-if="model == 'addTaxe'"></addTaxe>
  </div>
</template>
<script>
import axios from 'axios'

import formInput from '@/elements/add/form/formInput.vue'
import formTextarea from '@/elements/add/form/formTextarea.vue'
import connectionInput from '@/elements/add/form/connectionInput.vue'
import monyInput from '@/elements/add/form/monyInput.vue'
import selectInput from '@/elements/add/form/selectInput.vue'
import dvider from '@/elements/add/dvider.vue'
import addHeader from '@/elements/add/header.vue'
import loading from '@/elements/add/loading.vue'
import subFileInput from '@/elements/add/form/subFileInput.vue'

import addPaymentMethod from '@/elements/popupForms/addPaymentMethod.vue'
import addTaxe from './components/addTaxe.vue'
import searchGroupInput from '@/elements/add/form/searchGroupInput.vue'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  data() {
    return {
      path: '/incomes',
      item: {
        invoice_group: this.$option.income_invoice_group_id,
        payment_method_id: 0,
        safe_id: 0,
        date: '',
        project_id: 0,
        project_item_id: 0,
        type: 0,
        status: 1,
        sup_income_section_id: 0,
        customer_id: 0,
        customer: {},
        supplier_id: 0,
        supplier: {},
        project_id: 0,
        project: {},
        safe: {},
        paymentMethod: {}
      },
      model: false,
      errors: {
        cost: false,
        safe_id: false,
        invoice_group: false
      },
      incomesSections: [],
      selectedIncomesSections: []
    }
  },
  mounted() {
    this.$updateDatabase([
      'invoiceGroups',
      'customers',
      'suppliers',
      'projects',
      'projectItems',
      'safes',
      'paymentMethods',
      'taxes',
      'incomeSections'
    ])

    if (this.$route.name == 'incomesEdit') {
      this.$parent.stopEdit = true
      this.getItem()
    }

    if (this.$route.name == 'incomesCreate') {
      var params = this.$getParams()
      if (params.safe_id) {
        var safe = this.$database.safes.find((el) => el.id == params.safe_id)
        this.item.safe_id = params.safe_id
        this.item.safe = safe
      } else {
        if (this.$database.safes.length == 1) {
          this.item.safe_id = this.$database.safes[0].id
          this.item.safe = this.$database.safes[0]
        }
      }

      this.item.date = this.$nowDate()
    }
    this.incomesSections = this.$database.incomeSections.filter((el) => el.income_section_id == 0)

    var elm = this
    window.addEventListener('keydown', function (e) {
      if (e.key == 'F1' || e.key == 'Meta') {
        e.preventDefault()
        elm.saveItem()
      }
    })
  },
  methods: {
    getItem() {
      axios.get(this.$linkGenerator(this.path + '/' + this.$route.params.id)).then((response) => {
        this.item = response.data
        this.$parent.stopEdit = false
        this.item.date = this.$dateFormat(this.item.date, true)
      })
    },
    saveItem() {
      var error = 0
      if (typeof this.item.cost === 'undefined' || this.item.cost == '' || this.item.cost < 1) {
        error = 1
        this.errors.cost = true
      }
      if (
        this.item.type == 0 &&
        (typeof this.item.safe_id === 'undefined' ||
          this.item.safe_id == '' ||
          this.item.safe_id == 0)
      ) {
        error = 1
        this.errors.safe_id = true
      }
      if (
        (typeof this.item.invoice_group === 'undefined' ||
          this.item.invoice_group == 0 ||
          this.item.invoice_group == '' ||
          this.item.invoice_group == null) &&
        this.$route.name == 'incomesCreate'
      ) {
        error = 1
        this.errors.invoice_group = true
      }
      if (error == 0) {
        this.item.date = this.$fixDate(this.item.date)
        if (this.$route.name == 'incomesCreate') {
          this.$parent.aletText = this.$t('Income successfully added')
          this.$parent.alertType = 'success'
          this.$addToLocalDatabase(this.item, this.path.substring(1))

          var safe = this.$database.safes.find((el) => el.id == this.item.safe_id)
          if (safe && this.item.type == 0) {
            safe.balance = parseFloat(safe.balance) - parseFloat(this.item.cost)
          }
          localStorage.database = JSON.stringify(this.$database)

          this.$router.go(-1)
          this.$parent.stopEdit = false
        } else if (this.$route.name == 'incomesEdit') {
          this.item._method = 'PUT'
          this.$parent.stopEdit = true
          axios
            .post(this.$linkGenerator(this.path + '/' + this.item.id), this.item)
            .then((response) => {
              if (response.data == 'safe error') {
                this.$parent.aletText = this.$t('The employee is not tied to a safe')
                this.$parent.alertType = 'danger'
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                })
              } else if (response.data == 'money error') {
                this.$parent.aletText = this.$t('The amount is not in the safe')
                this.$parent.alertType = 'danger'
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                })
              } else {
                this.$parent.aletText = this.$t('Income has been modified successfully')
                this.$parent.alertType = 'success'
                this.$router.go(-1)
                this.$parent.stopEdit = false
                return response
              }
            })
        }
      } else {
        this.$parent.aletText = this.$t('Please make sure of the input')
        this.$parent.alertType = 'danger'
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    }
  },
  watch: {
    'item.income_section_id': function (val) {
      if (val == 0) {
        this.selectedIncomesSections = []
      } else {
        this.selectedIncomesSections = this.$database.incomesSections.filter(
          (el) => el.income_section_id == val
        )
      }
    }
  },
  components: {
    formInput,
    dvider,
    addHeader,
    monyInput,
    formTextarea,
    connectionInput,
    addPaymentMethod,
    addTaxe,
    loading,
    selectInput,
    subFileInput,

    VueCtkDateTimePicker,
    searchGroupInput
  }
}
</script>
